import React from 'react'
// import Image from 'next/image'
import { useEffect } from 'react';
import { useTranslation,Trans  } from 'react-i18next';
const Banner = () => {
    const { t } = useTranslation();
    useEffect(() => {
        // Select the container element
        const container = document.querySelector('.container');
        const target = document.querySelector('.serach-bar');

        if (container && target) {
            // Get the computed margin-right of the container
            const containerStyle = getComputedStyle(container);
            const marginRight = containerStyle.marginRight;

            // Set the custom CSS variable on the target element
            target.style.setProperty('--custom-left', marginRight);
            // console.log(`Margin-Right: ${marginRight}`);
        }
    }, []);


    return (
        <>
            <section className='bs-banner custom-margin-top'>
                <div className='banner-img'>
                    <img
                        className="img-fluid"
                        src="/images/about/hero-banner.jpg"
                        alt="logo"
                        width={1920}
                        height={500}
                    />
                </div>

                <div className='banner-text'>
                    <h2 className='hero-text typ-56' data-aos="fade-in" data-aos-delay="200">
                        <Trans i18nKey="bannerTitle" />
                   
                    </h2>
                </div>

            </section>
        </>
    )
}

export default Banner